import { observer } from "mobx-react-lite";
import { usePlayground } from "../../playground-store";
import SidebarWidget from "../SidebarWidget";

import { EmptyTestCasePlaceholder } from "./TestCase";
import EditTestCaseDialog from "./TestCase/EditTestCaseDialog";
import TestCases from "./TestCases";
import useScrollToNewElement from "./hooks/useScrollToNewElement";
import useVariableSetEditing from "./hooks/useVariableSetEditing";
import { usePlaygroundDialogStore } from "../../PlaygroundDialog/playground-dialog-store";
import { PlaygroundDialogType } from "../../PlaygroundDialog/constants";
import { useUser } from "@/context/user-context";

const TestCasesWidget = () => {
  const playground = usePlayground();
  const playgroundDialogStore = usePlaygroundDialogStore();
  const { isNewUser } = useUser();

  const { containerRef, scrollToEnd } = useScrollToNewElement();
  const { editingSetId, isEditingSet, startEditing, stopEditing } =
    useVariableSetEditing();

  const handleNewSetCreated = (setId: string, scroll = true) => {
    if (!localStorage.getItem("showInputVariablesTutorial") && isNewUser) {
      return;
    }

    startEditing(setId);
    scroll && setTimeout(scrollToEnd, 100);
  };

  const openTutorialDialog = () => {
    if (
      localStorage.getItem("showInputVariablesTutorial") === "false" ||
      !isNewUser
    ) {
      return;
    }

    playgroundDialogStore.setIsDialogOpen({
      isOpen: true,
      dialogType: PlaygroundDialogType.NoInputVariables,
      onClose: () => {
        const setId = playground.input_variable_sets[0].id;
        handleNewSetCreated(setId);
      },
    });
  };

  return (
    <SidebarWidget
      name="Input Variable Sets"
      count={playground.input_variable_sets.length}
    >
      <div
        key="content"
        className="flex flex-col gap-y-2"
        onClick={openTutorialDialog}
      >
        {playground.input_variable_sets.length === 0 ? (
          <EmptyTestCasePlaceholder onAdd={handleNewSetCreated} />
        ) : (
          <TestCases
            inputVariableSets={playground.input_variable_sets}
            containerRef={containerRef}
            onSetClick={handleNewSetCreated}
          />
        )}
      </div>
      <EditTestCaseDialog
        set={
          playground.input_variable_sets.find((set) => set.id === editingSetId)!
        }
        isOpen={isEditingSet}
        onClose={stopEditing}
      />
    </SidebarWidget>
  );
};

export default observer(TestCasesWidget);
